import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { playClickSound } from '@/utils/media';
import { withdraw } from '@/api/withdraw';
import { useUserStore } from '@/stores/user';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useWithdrawStore } from '@/stores/withdraw';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import WithdrawPopup from '@/themes/themeOne/withdraw/withdrawPopup.vue';
import { Channel, TAB_TYPE_LIST, WithdrawPopupData } from './supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'withdrawPopup',
  emits: ['handleClose'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n();
const userStore = useUserStore()
const withdrawStore = useWithdrawStore()
const uID = computed(() => userStore.id)
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()

const selectedChannel = computed(() => withdrawStore.selectedChannel as Channel)
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref('')
const emailID = ref('')
const phoneID = ref('')
const evpID = ref('')
const userName = ref('')
const cpfNumber = ref('')
const brazilID = ref('')
const bank = ref('')
const showCPFIdError = ref(true)
const showEmaiIdError = ref(true)
const showPhoneIdError = ref(true)
const showEvpIdError = ref(true)
const showCPFNumError = ref(false)
const activeButton = ref(false)
const selectedAmount = ref(0)
const isDisabled = ref(false)

const dataSet = computed<WithdrawPopupData>(() => ({
    show: show.value,
    selectedChannel: selectedChannel.value,
    activeTab: activeTab.value,
    cpfID: cpfID.value,
    emailID: emailID.value,
    phoneID: phoneID.value,
    evpID: evpID.value,
    userName: userName.value,
    cpfNumber: cpfNumber.value,
    brazilID: brazilID.value,
    bank: bank.value,
    showCPFIdError: showCPFIdError.value,
    showEmaiIdError: showEmaiIdError.value,
    showPhoneIdError: showPhoneIdError.value,
    showEvpIdError: showEvpIdError.value,
    showCPFNumError: showCPFNumError.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    isDisabled: isDisabled.value,
}))

const emits = __emit

const open = (amount: number, data: any) => {
    playClickSound()
    show.value = true
    selectedAmount.value = amount
    if (data) {
        cpfID.value = data.cpf || ''
        emailID.value = data.email || ''
        phoneID.value = data.phone || ''
        evpID.value = data.email || ''
        userName.value = data.userName || ''
        cpfNumber.value = data.cpfId || ''
        brazilID.value = data.brazilId || ''
        if (data?.isEditable == 1) {
            isDisabled.value = true
        } else {
            isDisabled.value = false
        }
    }
}
const close = () => {
    show.value = false
    emits('handleClose')
    cpfID.value = ''
    emailID.value = ''
    phoneID.value = ''
    evpID.value = ''
    userName.value = ''
    cpfNumber.value = ''
    brazilID.value = ''
    bank.value = ''
}

const selectTabType = (item: any) => {
    activeTab.value = item
    // checkFieldsFill()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const confirmWithdraw = () => {
    console.log('confirmWithdraw',emailID.value);
    loadingRef.value.open()
    let data: any = {
        payment_channel_id: selectedChannel.value.id,
        amount: selectedAmount.value,
        tax_type: activeTab.value.name,
        tax_id: activeTab.value.name == 'CPF' ? cpfID.value :
            activeTab.value.name == 'E-mail' ? emailID.value :
                activeTab.value.name == 'PHONE' ? phoneID.value :
                    activeTab.value.name == 'EVP' ? evpID.value : '',
        account_name: userName.value,
        cpf_id: cpfNumber.value,
        uid: uID.value,
    }

    if (selectedChannel.value.channelType === '1') {
        data.bank_name = bank.value
    } else if (selectedChannel.value.channelType === '7') {
        data.bank_name = bank.value
        data.identity_no = brazilID.value
    }
    withdraw(data).then(res => {
        loadingRef.value.close()
        showSuccess(res.msg)
        setTimeout(() => {
            userStore.getInfo()
            close()
        }, 500)
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
        setTimeout(() => {
            userStore.getInfo()
            close()
        }, 500)

    })
}
// const checkFieldsFill = () => {
   
//     if (activeTab.value.id == 1) {
//         activeButton.value = (cpfID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showCPFIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     } else if (activeTab.value.id == 2) {
//         activeButton.value = (emailID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showEmaiIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     } else if (activeTab.value.id == 3) {
//         activeButton.value = (phoneID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showPhoneIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     } else if (activeTab.value.id == 4) {
//         activeButton.value = (evpID.value != '') &&
//             (userName.value != '') &&
//             (cpfNumber.value != '') &&
//             !showEvpIdError.value &&
//             !showCPFNumError.value
//             ? true : false
//     }
//     console.log("checkFieldsFill called", activeButton.value);
// }
const valueChange = (data : any) =>{
    if(data.type === 'cpfID'){
        cpfID.value = data.value
    }else if(data.type === 'emailID'){
        emailID.value = data.value
    }else if(data.type === 'phoneID'){
        phoneID.value = data.value
    }else if(data.type === 'evpID'){
        evpID.value = data.value
    }else if(data.type === 'cpfNumber'){
        cpfNumber.value = data.value
    }else if(data.type === 'userName'){
        userName.value = data.value
    }else if(data.type === 'brazilID'){
        brazilID.value = data.value
    }else if(data.type === 'bank'){
        bank.value = data.value
    }
}
__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(WithdrawPopup, {
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
        "data-set": dataSet.value,
        onChangeValue: valueChange,
        onClose: close,
        onConfirmWithdraw: confirmWithdraw,
        onSelectTabType: selectTabType,
        onOpen: open
      }, null, 8, ["show", "data-set"])
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})